import React from 'react';
function FlagEn() {
return (
    <>
      <svg width="24px" height="24px" viewBox="0 -4 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_503_3900)">
        <rect width="28" height="20" rx="2" fill="white" />
        <mask id="mask0_503_3900" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="20">
            <rect width="28" height="20" rx="2" fill="white" /></mask><g mask="url(#mask0_503_3900)"><rect width="28" height="20" fill="#0E4CB5" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 12H8V20H12V12H28V8H12V0H8V8H0V12Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 10.6667H9.33333V20H10.6667V10.6667H28V9.33333H10.6667V0H9.33333V9.33333H0V10.6667Z" fill="#EB363A" /></g>
            </g><defs><clipPath id="clip0_503_3900"><rect width="28" height="20" rx="2" fill="white" /></clipPath></defs>
    </svg>

    </>
);
}
export default FlagEn;